import { handleResponse, authHeader } from '../helpers';

const BASE_URL = process.env.REACT_APP_API_URL;

export const configService = {
    getConfig,
    saveConfig,
    saveScript,
    rebuildCallList,
};

function getConfig() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}/config/setting` , requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        })
        .catch(err => {
            console.error(err)
        });
}

function saveConfig(config) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(config)
    };
    return fetch(`${BASE_URL}/config/setting` , requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        })
        .catch(err => {
            console.error(err)
        });
}

function saveScript(config) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(config)
    };
    return fetch(`${BASE_URL}/config/script` , requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        })
        .catch(err => {
            console.error(err)
        });
}

function rebuildCallList() {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}/admin/rebuild-call-list` , requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        })
        .catch(err => {
            console.error(err)
        });
}
